import React, { useState, useEffect } from "react";
import LoadingBar from "react-top-loading-bar";
import "./Loader.css";

export default function TopLoader(props) {
  // const [progress, setProgress] = useState(0);
  const loading = props.loading;
  // useEffect(() => {
  //     setProgress(loading);
  // }, [loading]);

  return (
    <>
      {loading < 100 && (
        <div className="full-page-loader">
          <div className="loader">
            <div className="spinner"></div>
          </div>
        </div>
      )}
    </>
  );
}
